import { BRAND_KEYS, type BrandKey } from '../../config/brands';
import { BRAND_PROFILES } from '../../config/brandProfiles';
import type { BrandFilter } from '../utils/brandFilter';

interface BrandFilterSelectProps {
  value: BrandFilter;
  onChange: (value: BrandFilter) => void;
  /** Set when a visible `<label htmlFor>` names the control; otherwise it names itself. */
  id?: string;
  className?: string;
}

/**
 * "All brands / BHCS / Kaleido" picker for an admin list.
 *
 * Defaults belong to the caller, and every caller so far defaults to all brands: an admin list
 * should not hide rows by default, and "All brands" keeps a screen exactly as it was for a
 * single-brand org.
 */
export function BrandFilterSelect({ value, onChange, id, className }: BrandFilterSelectProps) {
  return (
    <select
      id={id}
      aria-label={id ? undefined : 'Filter by brand'}
      className={
        className ??
        'shrink-0 px-3 py-1.5 text-sm border border-gray-300 rounded-md bg-white focus:outline-none focus:ring-2 focus:ring-blue-500'
      }
      value={value}
      onChange={(e) => onChange(e.target.value as BrandKey | 'all')}
    >
      <option value="all">All brands</option>
      {BRAND_KEYS.map((key) => (
        <option key={key} value={key}>
          {BRAND_PROFILES[key].shortName}
        </option>
      ))}
    </select>
  );
}
